// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comfirBox .newForm[data-v-78ee627e]:first-child{width:100%;margin:40px 140px}.comfirBox .newForm:first-child .queryItem1[data-v-78ee627e]{width:60%}[data-v-78ee627e] .el-dialog__footer{text-align:center}.formS[data-v-78ee627e]{border-bottom:1px solid silver;padding-bottom:20px}.tableBox[data-v-78ee627e]{width:80%;padding:20px 60px}", ""]);
// Exports
module.exports = exports;
